module.exports = __webpack_public_path__ + "static/fonts/Montserrat100italic.5ba39d1f.ttf";